import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_event_location_link_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_event_location_link.model';

export class StockLevelMonitoringEventLocationLinkModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_event_location_link: bl_inv_stock_level_monitoring_event_location_link_RowClass = new bl_inv_stock_level_monitoring_event_location_link_RowClass();
}
